<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Store Third ID"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`7- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Country name or ID"
            @input="updateThirdIdFiltered()"
            solo
            v-model="countryFiltered"
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-switch
            v-model="show_deleted"
            label="Show deleted"
            @change="syncFiltered()"
          ></v-switch>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-data-table
        :headers="headers"
        :items="storesFiltered"
        :loading="isLoading"
        sort-by="thirdIdStore"
        class="elevation-10"
        
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" v-if="isAdminUser" @click="edit(item)">
            mdi-pencil
          </v-icon>
        </template>
        <template v-slot:item.region="{ item }">
          <span v-if="!isRegionNull(item)">
            {{ item.region.thirdIdRegion }} - {{ item.region.name }}
          </span>
          <span v-if="isRegionNull(item)">No region found</span>
        </template>
        <template v-slot:item.country="{ item }">
          <span v-if="!isCountryNull(item)">
            {{ item.country.thirdIdCountry }} - {{ item.country.name }}
          </span>
          <span v-if="isCountryNull(item)">No country found</span>
        </template>
      </v-data-table>
    </v-container>


  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";
import router from "../../router";

export default {
  name: "Stores",
  data() {
    return {
      stores: [],
      storesFiltered: [],
      isLoading: true,
      id: "7",
      sub_id: null,
      third_id_filtered: "7--",
      isActive: false,
      show_deleted: false,
      countryFiltered: null,
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Name", value: "name" },
        { text: "Zone", value: "zone" },
        { text: "StoreID", value: "thirdIdStore" },
        { text: "Language", value: "language" },
        { text: "Region", value: "region" },
        { text: "Country", value: "country" },
        { text: "Begin", value: "begin" },
        { text: "End", value: "end" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    this.isLoading = true;
    await httpClient
      .get(`${parameters.posdataRefUrl}/stores`)
      .then((response) => {
        this.stores = response.data;
        this.isLoading = false;
        this.syncFiltered();
        
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.third_id_filtered =
        this.sub_id === null
          ? null
          : this.id + "-" + this.sub_id + "-" + this.sub_id;
      this.syncFiltered();
    },

    syncFiltered: function () {
      this.storesFiltered = new Array();
      this.stores.forEach((store) => {
        if (this.isStoreFiltered(store) && this.isDeleted(store)) {
          this.storesFiltered.push(store);
        }
      });
    },

    isStoreFiltered: function (store) {

      return (
        (this.third_id_filtered === null ||
          this.third_id_filtered === "7--" ||
          this.third_id_filtered === store.thirdIdStore) &&
        (this.countryFiltered === null ||
          this.countryFiltered === "" ||
          (!this.isCountryNull(store) &&
            (store.country.name.includes(this.countryFiltered) ||
              store.country.thirdIdCountry.includes(this.countryFiltered))))
      );
    },

    isDeleted: function (store) {
      return !this.show_deleted && store.end
        ? Date.parse(store.end) > Date.now()
        : true;
    },

    isCountryNull: function (store) {
      return store.country === null;
    },
    isRegionNull: function (store) {
      return store.region === null;
    },
    edit: function (item) {
      router.push({
        path: "editStore",
        query: { id: item.id },
      });
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/stores/Stores.vue